import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AgentData } from '../../features/FunctionalDesignXPLR/FunctionalRequirements/interfaces';

const initialState: AgentData = {
  useCase: {
    fetch: [],
  },
};

export const opportunitiesSlice = createSlice({
  name: 'opportunitiesSlice',
  initialState,
  reducers: {
    updateAgentsData: (state, action: PayloadAction<Partial<AgentData> | undefined>) => {
      const payload = action.payload || initialState;
      if (payload.useCase?.fetch) {
        state.useCase.fetch = payload.useCase.fetch;
      } else {
        state.useCase.fetch = [];
      }
    },
    resetDataInsight: () => initialState,
  },
});

export const { updateAgentsData, resetDataInsight } = opportunitiesSlice.actions;

export default opportunitiesSlice.reducer;
